import ApiService from "../../Services/ApiService";

export default class MenuService {

  get = () => {
    const url = "/menu/get";
    return new ApiService(process.env.REACT_APP_PORTAL_API_URL).get(url);
  };
}